import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26;

import i18next from "i18next";
import { PlatformType, constructRestaurantDetailsUrl } from "@dp/common";
import { computed, makeObservable, observable, runInAction } from "mobx";
import { WaitListUserStatus } from "../WaitListVisibility";
import { persist } from "mobx-persist";
var WaitListVisibilityModel = (_dec = persist("object"), (_class = /*#__PURE__*/function () {
  function WaitListVisibilityModel(platformUtil) {
    var _this = this;

    _classCallCheck(this, WaitListVisibilityModel);

    _initializerDefineProperty(this, "_appAttributes", _descriptor, this);

    _initializerDefineProperty(this, "_sessionDetails", _descriptor2, this);

    _initializerDefineProperty(this, "_estimatedWaitTime", _descriptor3, this);

    _initializerDefineProperty(this, "_currentDisplayTime", _descriptor4, this);

    _initializerDefineProperty(this, "_showHelpModal", _descriptor5, this);

    _initializerDefineProperty(this, "_isLocationPermissionAllowed", _descriptor6, this);

    _initializerDefineProperty(this, "_showLocationPermissionModal", _descriptor7, this);

    _initializerDefineProperty(this, "_showRetryLocationModal", _descriptor8, this);

    _initializerDefineProperty(this, "_showJoinWaitlistSuccessModal", _descriptor9, this);

    _initializerDefineProperty(this, "_isUserAlreadyInWaitlist", _descriptor10, this);

    _initializerDefineProperty(this, "_restaurantDetails", _descriptor11, this);

    _initializerDefineProperty(this, "_token", _descriptor12, this);

    _initializerDefineProperty(this, "_corporationID", _descriptor13, this);

    _initializerDefineProperty(this, "_showLeaveWaitlistModal", _descriptor14, this);

    _initializerDefineProperty(this, "_locationNumber", _descriptor15, this);

    _initializerDefineProperty(this, "_visitID", _descriptor16, this);

    _initializerDefineProperty(this, "_isByVisitToken", _descriptor17, this);

    _initializerDefineProperty(this, "_isByVisitId", _descriptor18, this);

    _initializerDefineProperty(this, "_pdfMenuUrl", _descriptor19, this);

    _initializerDefineProperty(this, "_visitData", _descriptor20, this);

    _initializerDefineProperty(this, "_fullWailist", _descriptor21, this);

    _initializerDefineProperty(this, "_isCheckinLoading", _descriptor22, this);

    _initializerDefineProperty(this, "_didUserPositionExceedsThreshold", _descriptor23, this);

    _initializerDefineProperty(this, "_wlErrorCode", _descriptor24, this);

    _initializerDefineProperty(this, "_wlErrorMessage", _descriptor25, this);

    _initializerDefineProperty(this, "visitIdLocalStatus", _descriptor26, this);

    _defineProperty(this, "platformUtil", void 0);

    _defineProperty(this, "shareRestInfo", function () {
      var _navigator, _this$restaurantDetai;

      var isFromFullWaitlistPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.share({
        title: ((_this$restaurantDetai = _this.restaurantDetails) === null || _this$restaurantDetai === void 0 ? void 0 : _this$restaurantDetai.restaurantName) || "",
        url: _this.shareBtnURL(isFromFullWaitlistPage),
        text: _this.shareBtnText
      })["catch"](function (err) {
        console.log("error in share:", err);
      });
    });

    this.platformUtil = platformUtil;
    makeObservable(this);
  }

  _createClass(WaitListVisibilityModel, [{
    key: "setAppAttributes",
    value: function setAppAttributes(_appAttributes) {
      var _this2 = this;

      runInAction(function () {
        _this2._appAttributes = _appAttributes;
      });
    }
  }, {
    key: "setSessionDetails",
    value: function setSessionDetails(_sessionDetails) {
      var _this3 = this;

      runInAction(function () {
        _this3._sessionDetails = _sessionDetails;
      });
    }
  }, {
    key: "setRestaurantDetails",
    value: function setRestaurantDetails(restDetails) {
      var _this4 = this;

      runInAction(function () {
        _this4._restaurantDetails = restDetails;
      });
    }
  }, {
    key: "shareBtnURL",
    value: function shareBtnURL(fromFullWaitlist) {
      var _this$platformUtil, _this$platformUtil2, _this$_restaurantDeta, _this$_restaurantDeta2, _this$_restaurantDeta3, _this$_restaurantDeta4, _this$_restaurantDeta5;

      var platform = (_this$platformUtil = this.platformUtil) === null || _this$platformUtil === void 0 ? void 0 : _this$platformUtil.PLATFORM_TYPE;
      var platformIsMobileApp = platform === PlatformType.APP ? true : false;
      var baseDomainURL = (_this$platformUtil2 = this.platformUtil) === null || _this$platformUtil2 === void 0 ? void 0 : _this$platformUtil2.getBaseDomainURL();
      var address = (_this$_restaurantDeta = this._restaurantDetails) === null || _this$_restaurantDeta === void 0 ? void 0 : (_this$_restaurantDeta2 = _this$_restaurantDeta.contactDetail) === null || _this$_restaurantDeta2 === void 0 ? void 0 : _this$_restaurantDeta2.address;
      var restaurantName = (_this$_restaurantDeta3 = this._restaurantDetails) === null || _this$_restaurantDeta3 === void 0 ? void 0 : (_this$_restaurantDeta4 = _this$_restaurantDeta3.restaurantName) === null || _this$_restaurantDeta4 === void 0 ? void 0 : _this$_restaurantDeta4.toLowerCase();
      var restaurantNum = (_this$_restaurantDeta5 = this._restaurantDetails) === null || _this$_restaurantDeta5 === void 0 ? void 0 : _this$_restaurantDeta5.restaurantNumber;
      var restDetailsURL = constructRestaurantDetailsUrl({
        state: address === null || address === void 0 ? void 0 : address.stateCode,
        city: address === null || address === void 0 ? void 0 : address.city,
        name: restaurantName,
        id: restaurantNum
      });

      if (!platformIsMobileApp) {
        var _window2, _window2$location, _document;

        if (!fromFullWaitlist) {
          var _URL, _window, _window$location;

          var origin = (_URL = new URL((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.href)) === null || _URL === void 0 ? void 0 : _URL.origin;
          return "".concat(origin).concat(restDetailsURL);
        }

        return ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.href) || ((_document = document) === null || _document === void 0 ? void 0 : _document.URL);
      }

      return "".concat(baseDomainURL).concat(restDetailsURL);
    }
  }, {
    key: "setVisitData",
    value: function setVisitData(_visitData) {
      var _this5 = this;

      runInAction(function () {
        _this5._visitData = _visitData;
      });
    }
  }, {
    key: "setFullWaitlist",
    value: function setFullWaitlist(_fullWailist) {
      var _this6 = this;

      runInAction(function () {
        _this6._fullWailist = _fullWailist;
      });
    }
  }, {
    key: "appAttributes",
    get: function get() {
      return this._appAttributes;
    }
  }, {
    key: "isUserAlreadyInWaitlist",
    set: function set(state) {
      var _this7 = this;

      runInAction(function () {
        _this7._isUserAlreadyInWaitlist = state;
      });
    },
    get: function get() {
      return this._isUserAlreadyInWaitlist;
    }
  }, {
    key: "isLocationPermissionAllowed",
    get: function get() {
      return this._isLocationPermissionAllowed;
    },
    set: function set(state) {
      var _this8 = this;

      runInAction(function () {
        _this8._isLocationPermissionAllowed = state;
      });
    }
  }, {
    key: "showLocationPermissionModal",
    get: function get() {
      return this._showLocationPermissionModal;
    },
    set: function set(state) {
      var _this9 = this;

      runInAction(function () {
        _this9._showLocationPermissionModal = state;
      });
    }
  }, {
    key: "showRetryLocationModal",
    get: function get() {
      return this._showRetryLocationModal;
    },
    set: function set(state) {
      var _this10 = this;

      runInAction(function () {
        _this10._showRetryLocationModal = state;
      });
    }
  }, {
    key: "showJoinWaitlistSuccessModal",
    get: function get() {
      return this._showJoinWaitlistSuccessModal;
    },
    set: function set(state) {
      var _this11 = this;

      runInAction(function () {
        _this11._showJoinWaitlistSuccessModal = state;
      });
    }
  }, {
    key: "estimatedWaitTime",
    get: function get() {
      return this._estimatedWaitTime;
    },
    set: function set(_estimatedWaitTime) {
      var _this12 = this;

      runInAction(function () {
        _this12._estimatedWaitTime = _estimatedWaitTime;
      });
    }
  }, {
    key: "currentlyDisplayTime",
    get: function get() {
      return this._currentDisplayTime;
    }
  }, {
    key: "currentDisplayTime",
    set: function set(_currentDisplayTime) {
      var _this13 = this;

      runInAction(function () {
        _this13._currentDisplayTime = _currentDisplayTime;
      });
    }
  }, {
    key: "partySize",
    get: function get() {
      var _this$_visitData;

      return (_this$_visitData = this._visitData) === null || _this$_visitData === void 0 ? void 0 : _this$_visitData.partySize;
    }
  }, {
    key: "showHelpModal",
    get: function get() {
      return this._showHelpModal;
    },
    set: function set(state) {
      var _this14 = this;

      runInAction(function () {
        _this14._showHelpModal = state;
      });
    }
  }, {
    key: "showLeaveWaitlistModal",
    get: function get() {
      return this._showLeaveWaitlistModal;
    },
    set: function set(state) {
      var _this15 = this;

      runInAction(function () {
        _this15._showLeaveWaitlistModal = state;
      });
    }
  }, {
    key: "pdfMenuUrl",
    get: function get() {
      return this._pdfMenuUrl;
    },
    set: function set(url) {
      var _this16 = this;

      runInAction(function () {
        _this16._pdfMenuUrl = url;
      });
    }
  }, {
    key: "restaurantDetails",
    get: function get() {
      return this._restaurantDetails;
    }
  }, {
    key: "directionsLink",
    get: function get() {
      var _this$platformUtil3, _this$_restaurantDeta6, _this$_restaurantDeta7, _address$coordinates, _address$coordinates2;

      var platform = (_this$platformUtil3 = this.platformUtil) === null || _this$platformUtil3 === void 0 ? void 0 : _this$platformUtil3.PLATFORM_TYPE;
      var platformIsMobileApp = platform === PlatformType.APP ? true : false;
      var address = (_this$_restaurantDeta6 = this._restaurantDetails) === null || _this$_restaurantDeta6 === void 0 ? void 0 : (_this$_restaurantDeta7 = _this$_restaurantDeta6.contactDetail) === null || _this$_restaurantDeta7 === void 0 ? void 0 : _this$_restaurantDeta7.address;
      var lat = address === null || address === void 0 ? void 0 : (_address$coordinates = address.coordinates) === null || _address$coordinates === void 0 ? void 0 : _address$coordinates.latitude;
      var lng = address === null || address === void 0 ? void 0 : (_address$coordinates2 = address.coordinates) === null || _address$coordinates2 === void 0 ? void 0 : _address$coordinates2.longitude;
      if (!platformIsMobileApp) return "geo:".concat(lat, ",").concat(lng, "?q=").concat(lat, ",").concat(lng, "(").concat(address === null || address === void 0 ? void 0 : address.street1, ")");else return "https://maps.google.com/?q=".concat(lat, ",").concat(lng, "(").concat(address === null || address === void 0 ? void 0 : address.street1, ")");
    }
  }, {
    key: "shareBtnText",
    get: function get() {
      var _this$_restaurantDeta8, _this$_restaurantDeta9, _this$_restaurantDeta10, _this$visitData;

      var locationName = (_this$_restaurantDeta8 = this._restaurantDetails) === null || _this$_restaurantDeta8 === void 0 ? void 0 : _this$_restaurantDeta8.restaurantName;
      var address = (_this$_restaurantDeta9 = this._restaurantDetails) === null || _this$_restaurantDeta9 === void 0 ? void 0 : (_this$_restaurantDeta10 = _this$_restaurantDeta9.contactDetail) === null || _this$_restaurantDeta10 === void 0 ? void 0 : _this$_restaurantDeta10.address;
      var addressText = "";

      if (address !== null && address !== void 0 && address.street1) {
        addressText += "".concat(address === null || address === void 0 ? void 0 : address.street1, ", ");
      }

      if (address !== null && address !== void 0 && address.street2) {
        addressText += "".concat(address === null || address === void 0 ? void 0 : address.street2, ", ");
      }

      if (address !== null && address !== void 0 && address.city) {
        addressText += "".concat(address === null || address === void 0 ? void 0 : address.city, ", ");
      }

      if (address !== null && address !== void 0 && address.stateCode) {
        addressText += "".concat(address === null || address === void 0 ? void 0 : address.stateCode, ", ");
      }

      if (address !== null && address !== void 0 && address.zipCode) {
        addressText += "".concat(address === null || address === void 0 ? void 0 : address.zipCode);
      } // check user checkin status and append the message accordingly


      if ((this === null || this === void 0 ? void 0 : (_this$visitData = this.visitData) === null || _this$visitData === void 0 ? void 0 : _this$visitData.status) === WaitListUserStatus.NotYetArrived) {
        var _this$visitData2;

        var quote = this === null || this === void 0 ? void 0 : (_this$visitData2 = this.visitData) === null || _this$visitData2 === void 0 ? void 0 : _this$visitData2.quote;
        var lq = quote === null || quote === void 0 ? void 0 : quote.lowTime;
        var hq = quote === null || quote === void 0 ? void 0 : quote.highTime;
        return i18next.t("share.waitlist.pre_checkin_message", {
          defaultValue: "Hey, I have successfully joined waitlist in ".concat(locationName, " \n").concat(addressText, ". Your table will be ready in ").concat(lq, " - ").concat(hq, " minutes.\n "),
          interpolation: {
            prefix: "${",
            suffix: "}"
          },
          0: locationName,
          1: addressText,
          2: lq,
          3: hq
        });
      } else {
        return i18next.t("share.waitlist.post_checkin_message", {
          defaultValue: "Hey, I have successfully joined waitlist in ".concat(locationName, " \n").concat(addressText, ". You will receive text message when your table is ready.\n "),
          interpolation: {
            prefix: "${",
            suffix: "}"
          },
          0: locationName,
          1: addressText
        });
      }
    }
  }, {
    key: "isOrderAheadEnabled",
    get: function get() {
      var _this$_restaurantDeta11, _this$_restaurantDeta12;

      return !!((_this$_restaurantDeta11 = this._restaurantDetails) !== null && _this$_restaurantDeta11 !== void 0 && (_this$_restaurantDeta12 = _this$_restaurantDeta11.features) !== null && _this$_restaurantDeta12 !== void 0 && _this$_restaurantDeta12.orderAheadEnabled);
    }
  }, {
    key: "isRemoteCheckinEnabled",
    get: function get() {
      var _this$_restaurantDeta13, _this$_restaurantDeta14;

      return (_this$_restaurantDeta13 = this._restaurantDetails) === null || _this$_restaurantDeta13 === void 0 ? void 0 : (_this$_restaurantDeta14 = _this$_restaurantDeta13.features) === null || _this$_restaurantDeta14 === void 0 ? void 0 : _this$_restaurantDeta14.waitlistCheckinEnabled;
    }
  }, {
    key: "isFullWLVisibilityEnabled",
    get: function get() {
      var _this$_restaurantDeta15, _this$_restaurantDeta16;

      return (_this$_restaurantDeta15 = this._restaurantDetails) === null || _this$_restaurantDeta15 === void 0 ? void 0 : (_this$_restaurantDeta16 = _this$_restaurantDeta15.features) === null || _this$_restaurantDeta16 === void 0 ? void 0 : _this$_restaurantDeta16.waitlistFullVisibilityEnabled;
    }
  }, {
    key: "isWaitlistVisibilityEnabled",
    get: function get() {
      var _this$_restaurantDeta17, _this$_restaurantDeta18;

      return (_this$_restaurantDeta17 = this._restaurantDetails) === null || _this$_restaurantDeta17 === void 0 ? void 0 : (_this$_restaurantDeta18 = _this$_restaurantDeta17.features) === null || _this$_restaurantDeta18 === void 0 ? void 0 : _this$_restaurantDeta18.waitlistVisibilityEnabled;
    }
  }, {
    key: "token",
    get: function get() {
      return this._token;
    },
    set: function set(_token) {
      var _this17 = this;

      runInAction(function () {
        _this17._token = _token;
      });
    }
  }, {
    key: "isByVisitToken",
    get: function get() {
      return this._isByVisitToken;
    },
    set: function set(state) {
      var _this18 = this;

      runInAction(function () {
        _this18._isByVisitToken = state;
      });
    }
  }, {
    key: "isByVisitId",
    get: function get() {
      return this._isByVisitId;
    },
    set: function set(state) {
      var _this19 = this;

      runInAction(function () {
        _this19._isByVisitId = state;
      });
    }
  }, {
    key: "corporationID",
    get: function get() {
      return this._corporationID;
    },
    set: function set(_corporationID) {
      var _this20 = this;

      runInAction(function () {
        _this20._corporationID = _corporationID;
      });
    }
  }, {
    key: "locationNumber",
    get: function get() {
      return this._locationNumber;
    },
    set: function set(_locationNumber) {
      var _this21 = this;

      runInAction(function () {
        _this21._locationNumber = _locationNumber;
      });
    }
  }, {
    key: "visitID",
    get: function get() {
      return this._visitID;
    },
    set: function set(_visitID) {
      var _this22 = this;

      runInAction(function () {
        _this22._visitID = _visitID;
      });
    }
  }, {
    key: "visitData",
    get: function get() {
      return this._visitData;
    }
  }, {
    key: "isCheckinLoading",
    set: function set(_val) {
      var _this23 = this;

      runInAction(function () {
        _this23._isCheckinLoading = _val;
      });
    },
    get: function get() {
      return this._isCheckinLoading;
    }
  }, {
    key: "fullWaitlist",
    get: function get() {
      var _this$_fullWailist,
          _this$_fullWailist$vi,
          _this$_fullWailist$vi2,
          _this24 = this;

      var fullWL = (_this$_fullWailist = this._fullWailist) === null || _this$_fullWailist === void 0 ? void 0 : (_this$_fullWailist$vi = _this$_fullWailist.visits) === null || _this$_fullWailist$vi === void 0 ? void 0 : (_this$_fullWailist$vi2 = _this$_fullWailist$vi.visit) === null || _this$_fullWailist$vi2 === void 0 ? void 0 : _this$_fullWailist$vi2.map(function (visit) {
        var _this24$_visitData, _this24$_visitData$gu, _visit$guest, _visit$guest$lastName;

        var isCurrentUser = visit.guest.guestID === ((_this24$_visitData = _this24._visitData) === null || _this24$_visitData === void 0 ? void 0 : (_this24$_visitData$gu = _this24$_visitData.guest) === null || _this24$_visitData$gu === void 0 ? void 0 : _this24$_visitData$gu.guestID);
        return {
          position: visit.placeInWaitlist,
          id: visit.id,
          name: isCurrentUser ? "You" : visit === null || visit === void 0 ? void 0 : (_visit$guest = visit.guest) === null || _visit$guest === void 0 ? void 0 : (_visit$guest$lastName = _visit$guest.lastName) === null || _visit$guest$lastName === void 0 ? void 0 : _visit$guest$lastName.replace(/./g, "*"),
          partySize: visit.partySize,
          checkedIn: isCurrentUser ? true : (visit === null || visit === void 0 ? void 0 : visit.status) !== WaitListUserStatus.NotYetArrived,
          joinedBy: visit.kind,
          user: isCurrentUser
        };
      });
      return fullWL === null || fullWL === void 0 ? void 0 : fullWL.sort(function (v1, v2) {
        return (v1 === null || v1 === void 0 ? void 0 : v1.position) - (v2 === null || v2 === void 0 ? void 0 : v2.position);
      });
    }
  }, {
    key: "maxWaitlistPostionThreshold",
    get: function get() {
      var _this$_appAttributes, _this$_appAttributes$;

      return (_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : (_this$_appAttributes$ = _this$_appAttributes.configs) === null || _this$_appAttributes$ === void 0 ? void 0 : _this$_appAttributes$.waitlist_position_threshold;
    }
  }, {
    key: "didUserPositionExceedsThreshold",
    set: function set(val) {
      var _this25 = this;

      runInAction(function () {
        _this25._didUserPositionExceedsThreshold = val;
      });
    },
    get: function get() {
      return this._didUserPositionExceedsThreshold;
    }
  }, {
    key: "enableGeoFence",
    get: function get() {
      var _restDetail$features, _appAttr$configs;

      var restDetail = this._restaurantDetails;
      var appAttr = this._appAttributes;
      return !!(restDetail !== null && restDetail !== void 0 && (_restDetail$features = restDetail.features) !== null && _restDetail$features !== void 0 && _restDetail$features.enableGeoFence) && (appAttr === null || appAttr === void 0 ? void 0 : (_appAttr$configs = appAttr.configs) === null || _appAttr$configs === void 0 ? void 0 : _appAttr$configs.enableGeoFence);
    }
  }, {
    key: "geoFenceLocationRadius",
    get: function get() {
      var restDetail = this._restaurantDetails;
      var appAttr = this._appAttributes;

      if (restDetail && restDetail.geoFenceLocationRadius) {
        return restDetail === null || restDetail === void 0 ? void 0 : restDetail.geoFenceLocationRadius;
      } else {
        var _appAttr$configs2;

        return (appAttr === null || appAttr === void 0 ? void 0 : (_appAttr$configs2 = appAttr.configs) === null || _appAttr$configs2 === void 0 ? void 0 : _appAttr$configs2.geoFenceLocationRadius) || 0;
      }
    }
  }, {
    key: "wlErrorCode",
    set: function set(_val) {
      var _this26 = this;

      runInAction(function () {
        _this26._wlErrorCode = _val;
      });
    },
    get: function get() {
      return this._wlErrorCode;
    }
  }, {
    key: "wlErrorMessage",
    set: function set(_val) {
      var _this27 = this;

      runInAction(function () {
        _this27._wlErrorMessage = _val;
      });
    },
    get: function get() {
      return this._wlErrorMessage;
    }
  }]);

  return WaitListVisibilityModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_estimatedWaitTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "20-25";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_currentDisplayTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "7:28 pm";
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_showHelpModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_isLocationPermissionAllowed", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_showLocationPermissionModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_showRetryLocationModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_showJoinWaitlistSuccessModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_isUserAlreadyInWaitlist", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_restaurantDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_token", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_corporationID", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_showLeaveWaitlistModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_locationNumber", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_visitID", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_isByVisitToken", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_isByVisitId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "_pdfMenuUrl", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "_visitData", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "_fullWailist", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "_isCheckinLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "_didUserPositionExceedsThreshold", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "_wlErrorCode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "_wlErrorMessage", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "visitIdLocalStatus", [_dec, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "appAttributes", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "appAttributes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isUserAlreadyInWaitlist", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isUserAlreadyInWaitlist"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLocationPermissionAllowed", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLocationPermissionAllowed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showLocationPermissionModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showLocationPermissionModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showRetryLocationModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showRetryLocationModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showJoinWaitlistSuccessModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showJoinWaitlistSuccessModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "estimatedWaitTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "estimatedWaitTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentlyDisplayTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentlyDisplayTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "partySize", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "partySize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showHelpModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showHelpModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showLeaveWaitlistModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showLeaveWaitlistModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pdfMenuUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pdfMenuUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "directionsLink", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "directionsLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shareBtnText", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "shareBtnText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOrderAheadEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderAheadEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isRemoteCheckinEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isRemoteCheckinEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isFullWLVisibilityEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFullWLVisibilityEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isWaitlistVisibilityEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isWaitlistVisibilityEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "token", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "token"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isByVisitToken", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isByVisitToken"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isByVisitId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isByVisitId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "corporationID", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "corporationID"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "locationNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "locationNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "visitID", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "visitID"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "visitData", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "visitData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCheckinLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCheckinLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fullWaitlist", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "fullWaitlist"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxWaitlistPostionThreshold", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maxWaitlistPostionThreshold"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "didUserPositionExceedsThreshold", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "didUserPositionExceedsThreshold"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enableGeoFence", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "enableGeoFence"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "geoFenceLocationRadius", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "geoFenceLocationRadius"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wlErrorCode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "wlErrorCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wlErrorMessage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "wlErrorMessage"), _class.prototype)), _class));
export { WaitListVisibilityModel as default };